export enum GameState {
  Created,
  Started,
  Ended,
}
